

























import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import moment from 'moment';
import ActivitiesList from '@activities/components/lists/activities-list.vue';

@Component({
  name: 'bpc-club-courses',
  components: {
    'bpc-activities-list': ActivitiesList,
    'bpc-content-wrapper': ContentWrapper,
  },
})
export default class ClubCourses extends Vue {
  // PROPS
  /* Lifecycle hooks */
  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
  // DATA
  timestamp = moment().unix();
  // COMPUTED
  get actionsPortalTarget() {
    return `activity-actions-${this.timestamp}`;
  }
  // METHODS
  setUrlParams(params) {
    this.$router.push({ query: params }).catch(e => {
      return null;
    });
  }
  // WATCHERS
}
